import React, { useState } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Plans from "./pages/Plans/Plans";
import Fund from "./pages/Fund";
import Transaction from "./pages/Transaction";
import Shares from "./pages/Report";

function MainPlatform() {
  const { path } = useRouteMatch();
  const [fundData, setFundData] = useState([]);
  const [companies, setCompanies] = useState([
    { name: "Aramco", staticPrice: 37, customPrice: 37 },
    { name: "SABIC", staticPrice: 100, customPrice: 100 },
    { name: "Al Rajhi", staticPrice: 70, customPrice: 70 },
    { name: "STC", staticPrice: 45, customPrice: 45 },
    { name: "Ma'aden", staticPrice: 80, customPrice: 80 },
  ]);

  return (
    <Switch>
      <Route exact path={path} component={Dashboard} />
      <Route path={`${path}/plans`} render={(props) => <Plans {...props} setFundData={setFundData} />} />
      <Route path={`${path}/fund`} render={(props) => <Fund {...props} fundData={fundData} setFundData={setFundData} />} />
      <Route path={`${path}/transaction`} render={(props) => (
        <Transaction {...props} fundData={fundData} setFundData={setFundData} companies={companies} setCompanies={setCompanies} />
      )} />
      <Route path={`${path}/report`} render={(props) => (
        <Shares {...props} fundData={fundData} companies={companies} setCompanies={setCompanies} />
      )} />
      <Route path="*">
        <div style={{ color: "red" }}>404 inside MainPlatform</div>
      </Route>
    </Switch>
  );
}

export default MainPlatform;
